/** Transmissions not shown as chips; defaults must not pre-select them (phantom filters). */
export const TRANSMISSION_OPTIONS_EXCLUDED = ['TRANSMISSION_SEMI_AUTOMATIC'] as const;

const TRANSMISSION_EXCLUDED_SET = new Set<string>(TRANSMISSION_OPTIONS_EXCLUDED);

export function isTransmissionExcluded(transmission: string): boolean {
  return TRANSMISSION_EXCLUDED_SET.has(transmission);
}
